import View from './view';

export default View.extend( {

    events: {
        'click .-set-page'(e) {
            const {arrayIndex} = e.currentTarget.dataset;

            const {breadcrumbs, parentProperty} = this.options;
            const [lastCrumb] = [...breadcrumbs].reverse();
            const [page] = parentProperty.children
                .filter( childProperty => childProperty.name == lastCrumb.name )
                .filter( childProperty => childProperty.array_index == arrayIndex );

            this.trigger( 'set-page', page );
        }
    },

    serialize() {
        const {breadcrumbs, parentProperty} = this.options;

        let pages;
        if (breadcrumbs.length && parentProperty) {
            const [lastCrumb] = [...breadcrumbs].reverse();
            pages = parentProperty.children
                .filter( childProperty => childProperty.name == lastCrumb.name )
                .sort( (a, b) => a.array_index - b.array_index );
            if (pages.length === 1)
                pages = [];
        }

        return {
            breadcrumbs,
            pages,
        }
    }
} );


// WEBPACK FOOTER //
// ./src/js/view/config.breadcrumb.js